import InfoBar from "../objects/infobar";
import TweenedText from "../objects/text";
import Game from "../game";
import { GameScene } from "./game-scene";
import PlayerImage from "../leaderboard/PlayerImage";
import PlayerName from "../leaderboard/PlayerName";
import PlayerRank from "../leaderboard/PlayerRank";
import PlayerScore from "../leaderboard/PlayerScore";
import { SDKManager } from "../lib/SDKManager";

export class HUDScene extends Phaser.Scene {
  public game: Game;
  private bitmapTexts: Phaser.GameObjects.Text[];
  private _healthBar: InfoBar;

  private _points: number = 0;
  private _pointsBar: Phaser.GameObjects.Image;
  private _pointsIcon: Phaser.GameObjects.Image;
  private _healthBarIcon: Phaser.GameObjects.Image;
  private _livesIcon: Phaser.GameObjects.Image;

  private _highestScore: number = 0;

  private _healthIconTween: Phaser.Tweens.Tween;
  private _pointsIconTween: Phaser.Tweens.Tween;
  private _livesIconTween: Phaser.Tweens.Tween;
  private _blood: Phaser.GameObjects.Image;

  private _wreckedText: TweenedText;
  private _gameOverContainer: Phaser.GameObjects.Container;
  private _tournamentGameOverContainer: Phaser.GameObjects.Container;
  private _finalScore: Phaser.GameObjects.Text;

  private _gameOverTween: Phaser.Tweens.Tween;
  private _tournamentGameOverTween: Phaser.Tweens.Tween;

  private _adPanelContainer: Phaser.GameObjects.Container;

  private _pauseMenuContainer: Phaser.GameObjects.Container;
  private _transitionBanner: Phaser.GameObjects.Image;

  private _pauseText: Phaser.GameObjects.Text;
  private _pauseButton: Phaser.GameObjects.Image;

  private _noAdContainer: Phaser.GameObjects.Container;
  private _centerPressButton: Phaser.GameObjects.Sprite;

  private _fps: Phaser.GameObjects.Text;

  private _reSpawningContainer: Phaser.GameObjects.Container;

  private _adTimerTween: Phaser.Tweens.Tween;
  private _adTimerText: Phaser.GameObjects.Text;
  private _adTimerMask: Phaser.GameObjects.Graphics;
  private _adTimerFill: Phaser.GameObjects.Image;
  private _adTimerButtonClicked: boolean = false;

  private _muteButton: Phaser.GameObjects.Image;

  private _adWaitingPanelContianer: Phaser.GameObjects.Container;

  private isRewardedAD: Boolean = false;
  private _canRevive: Boolean = false;
  private _canDoubleScore: Boolean = false;
  private _isSkippedRevive: Boolean = false;

  private _lives: number = 3;

  private playerProfile: Phaser.GameObjects.Image;
  private playerName: Phaser.GameObjects.Text;

  private _instructionText: Phaser.GameObjects.Text;

  constructor() {
    super({
      key: "HUDScene"
    });
  }

  init(): void {
    this.bitmapTexts = [];
    this._healthBar = null;
    this._pointsBar = null;
    this._pointsIcon = null;
    this._healthBarIcon = null;
    this._healthIconTween = null;
    this._pointsIconTween = null;
    this._livesIcon = null;
    this._livesIconTween = null;
    this._blood = null;
    this._wreckedText = null;
    this._gameOverContainer = null;
    this._tournamentGameOverContainer = null;
    this._finalScore = null;
    this._gameOverTween = null;
    this._adWaitingPanelContianer = null;
    this.input.removeAllListeners();
    if (this.input.keyboard) {
      this.input.keyboard.removeAllListeners();
    }
    this._lives = this.getLives();

    // window.gameEvents.on('PauseGame', this.onGamePaused, this);
    // window.gameEvents.on('ResumeGame', this.onGameResume, this);
    // window.gameEvents.on('OnWatchAd', this.onAdWatch, this);
    // window.gameEvents.on('OnAdClose', this.onAdClose, this);
    // window.gameEvents.on('RestartGame', this.onGameRestart, this);
    window.gameEvents.on("onNoVideoAd", this._genericFlow.bind(this, "reward_fail"));
    window.gameEvents.on("gotoMenu", this.exitGame.bind(this), this);
    // if (FBInstantManager.canSetTournamentGameOver) {
    //   FBInstantManager.canSetTournamentGameOver = false;
    //   window.gameEvents.on("onTournamentGameOver", this._createTournamentGameOverScreen.bind(this));
    // }

    // let photo = FBInstantManager.playerPicURL;
    // this.load.image('player-image', photo);
    // this.load.once('filecomplete-image-player-image', this.addPlayerPhoto, this);
    // this.load.start();
    // this.facebook.loadPlayerPhoto(this, "player").once('photocomplete', this.addPlayerPhoto, this);
  }

  addPlayerPhoto(key) {
    this.playerProfile = this.add.image(300, 300, key);
    this.playerProfile.setScale(0.25, 0.25);
    this.playerProfile.setPosition(window.constants["BASE_WIDTH"] - Math.floor(this._pointsIcon.width * 7.35), window.constants["BASE_HEIGHT"] - Math.floor(this._pointsIcon.height * 0.85));
  }

  getLives() {
    if (typeof window.lives != 'undefined') {
      return window.lives;
    }
    return 3;
  }

  create(): void {
    this._points = 0;
    this._createSDHudBars();

    this._blood = this.add.image(window.constants.BASE_WIDTH / 2, window.constants.BASE_HEIGHT / 2, "assets", 'blood');
    this._blood.setScale((window.constants["HD_FLAG"]) ? 1.15 : 1);
    this._setBloodVisibility(0);

    let fontSize = (window.constants["HD_FLAG"]) ? 45 : 12;
    this._wreckedText = new TweenedText(this, window.constants.BASE_WIDTH / 2, window.constants.BASE_HEIGHT / 3.5, "WRECKED", null, 1.5, 0, { fontSize: fontSize, fontFamily: "font_3" });
    this._createGameOverScreen();
    this._instructionText = this.add.text(window.constants.BASE_WIDTH / 2, window.constants.BASE_HEIGHT / 1.2, "swipe left or right to move", { fontSize: fontSize - 5, fontFamily: "font_3" });
    this._instructionText.setOrigin(0.5);
    this.time.delayedCall(3000, () => {
      this._instructionText.visible = false;
    });

    this._addEventListeners();
    this._createAdScreen();
    this._createNoAdScreen();
    this._createReSpawningScreen();
    this._createHDPauseFlow();
    this._createMuteButton();
    // this._createFPS();
    this._setPauseButtonVisibility(false);
    this._createAdWaitingPanel();

    this._showLoadingScreen();

    // this.playerProfile = this.add.image(0, 0, 'player_image');
    // this.playerProfile.setScale(0.25, 0.25);
    // this.playerProfile.setPosition(window.constants["BASE_WIDTH"] - Math.floor(this._pointsIcon.width * 7.35), window.constants["BASE_HEIGHT"] - Math.floor(this._pointsIcon.height * 0.85));

    // this.playerName = this.add.text(0, 0, FBInstantManager.playerName, { fontSize: "50px", fontFamily: 'font_3' });
    // this.playerName.setPosition(window.constants["BASE_WIDTH"] - Math.floor(this._pointsIcon.width * 6.5), window.constants["BASE_HEIGHT"] - Math.floor(this._pointsIcon.height * 0.7));
  }

  private onGamePaused() {
    this._onPauseButtonPress();
  }

  private onGameResume() {
    this._onPauseToResume();
  }

  private onGameRestart() {
    this.checkHighestScore();
    if (this.game.sound.volume == 1) {
      this.game.sound.mute = false;
    }
    this._lives = this.getLives();
    this._cleanUp(false);
    this.events.emit("resumeGame");
  }

  private onAdWatch() {
    this._showLoadingScreen(true);
  }

  private onAdClose(isRewardGranted: boolean) {
    console.log("Reward Granted: " + isRewardGranted);
    this._showLoadingScreen(false);

    if (this.isRewardedAD && this._canRevive) {
      this.isRewardedAD = false;
      this._canRevive = false;
      if (isRewardGranted) {
        window.constants["SDK"].adsWatchedCount += 1;
        this._lives = 1;
        this._genericFlow("reward_success");
      } else {
        this._canRevive = false;
        this._isSkippedRevive = false;
        this._canDoubleScore = true;
        this._adText = "WATCH AN AD\nTO DOUBLE THE SCORE";
        this._adScreenMessage.setText(this._adText);
        this._genericFlow("check_for_ad");
      }
    } else if (this.isRewardedAD && this._canDoubleScore) {
      this.isRewardedAD = false;
      this._canDoubleScore = false;
      if (isRewardGranted) {
        this._points *= 2;
        this._genericFlow("reward_fail");
      } else {
        this._genericFlow("reward_fail");
      }
    } else {
      this._lives = this.getLives();
      this.restart();
    }

  }

  private onRestartGame() {

    this._showLoadingScreen(false);
    this._lives = this.getLives();
    this.restart();
  }

  restart() {
    this.checkHighestScore();
    if (this.game.sound.volume == 1) {
      this.game.sound.mute = false;
    }
    this._cleanUp(false);
    this.events.emit("resumeGame");
  }

  private checkHighestScore() {
    this._highestScore = GameScene.calculateHighScore(this._points);
    if (this._points == this._highestScore) {
      SDKManager.setPlayerHighscoreMetaData(this._highestScore);
      this.highScoreText.style.color = "#ffff80";
      this.highScoreText.setText("New Highscore!");
      this.highScoreTextTween.restart();
    }
    else {
      this.highScoreTextTween.stop(0);
      this.highScoreText.style.color = "#a3a3a3";
      this.highScoreText.setText("Highscore " + this._highestScore);
    }
  }
  // ============================ code for creation of screens start ============================

  private _createHudBars() {
    let healthBar = this.textures.getFrame("assets", 'health_bar');
    let health = this.textures.getFrame("assets", 'health_bar_icon');
    let pointBar = this.textures.getFrame("assets", 'points_bar');
    let coin = this.textures.getFrame("assets", 'coin');

    this._pointsBar = this.add.image(pointBar.width / 2 + coin.width, (healthBar.height / 2) + (health.height / 2), "assets", 'points_bar');
    this._pointsIcon = this.add.image(coin.width, coin.height * 1.6, "assets", 'points_bar_icon');
    // this._pointsIcon.setScale(2, 2);
    this._healthBar = new InfoBar(this, null, 10, healthBar.width, healthBar.height, "assets", 'health_bar', false, window.constants["BASE_WIDTH"] - ((healthBar.width / 2) + coin.width), (healthBar.height / 2) + (health.height / 2));
    this._healthBar.start();
    this._healthBarIcon = this.add.image(window.constants["BASE_WIDTH"] - ((coin.width)), (health.height), "assets", 'health_bar_icon')
    let fontSize = (window.constants.HD_FLAG) ? 40 : 10;
    // create bitmap texts

    this.bitmapTexts[0] = this.add.text(
      coin.width + pointBar.width / 2,
      pointBar.height / 2 + health.height / 2,
      `${this.registry.get("points")}`,
      { fontSize: fontSize, fontFamily: "font_2" },
    );

    this.bitmapTexts[0].setOrigin(0.5, 0.5);
    // this.bitmapTexts[1].setOrigin(0.5, 0.5);

    this._healthIconTween = this.add.tween({
      targets: this._healthBarIcon,
      scale: { from: 1, to: 1.3 },
      ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
      duration: 100,
      repeat: 0,            // -1: infinity
      yoyo: true
    })

    this._pointsIconTween = this.add.tween({
      targets: this._pointsIcon,
      scale: { from: 1, to: 1.3 },
      ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
      duration: 150,
      repeat: 0,            // -1: infinity
      yoyo: true
    })

  }

  private _createHDPauseFlow() {
    let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;

    // containers
    this._pauseMenuContainer = this.add.container(w2, h2 * 0.8);
    this._pauseMenuContainer.setDepth(40);

    // the bars
    let fontSize = (window.constants.HD_FLAG) ? 70 : 8;

    let pauseText = this.add.text(0, 0, "paused", { fontFamily: "font_3", fontSize: fontSize });
    pauseText.setOrigin(0.5);

    //text
    this._pauseButton = this.add.image(0, 0, "assets", "pause_button");
    let resume_button = this.add.image(0, 0, "assets", "resume_button");
    if (!window.constants["HD_FLAG"]) {
      this._pauseButton.setScale(0.7);
    }
    let replay_button = this.add.image(0, 0, "replay_button");
    let exit_button = this.add.image(0, 0, "exit_button");
    let buttWidth = this._pauseButton.width * this._pauseButton.scaleX, buttHeight = Math.floor(this._pauseButton.height * 0.55 * this._pauseButton.scaleY);
    this._pauseButton.setPosition(window.constants["BASE_WIDTH"] - buttWidth * 0.8, this.bitmapTexts[0].y + 150);
    resume_button.setPosition(-resume_button.displayWidth, pauseText.height * 0.8);
    replay_button.setPosition(0, pauseText.height * 0.8);
    exit_button.setPosition(exit_button.displayWidth, pauseText.height * 0.8);

    pauseText.setPosition(0, -pauseText.height * 1.3);

    resume_button.setScale(0.7);
    replay_button.setScale(0.75);
    exit_button.setScale(0.75);

    let rectangle = this.add.image(0, 0, "bg_panel");
    // let rectangle = this.add.rectangle(0, 0, window.constants.BASE_WIDTH, replay_button.height * 3, 0x000000, 0.85);

    // adding assets to container
    this._pauseMenuContainer.add([rectangle, replay_button, resume_button, exit_button, pauseText]); // text2, text3, text4
    this._handleInputListeners("keyup", this._onNormalHudScreenKeyPress, true);
    this._setPauseScreenVisibility(false);

    let banner = this.textures.getFrame("assets", "menu_banner");
    let scaleX = window.constants["BASE_WIDTH"] / banner.width;
    let scaleY = window.constants["BASE_HEIGHT"] / banner.height;
    this._transitionBanner = this.add.image(w2, h2, "assets", "menu_banner");
    this._transitionBanner.setScale(scaleX, scaleY);
    this._transitionBanner.setDepth(50);
    this._transitionBanner.setVisible(false);


    // set touch events
    if (window.constants["HD_FLAG"]) {
      this._pauseButton.setInteractive();
      replay_button.setInteractive();
      resume_button.setInteractive();
      exit_button.setInteractive();
      // this._pauseText.addListener("pointerdown", this._onButtonDown.bind(this, {text: this._pauseText, button: this._pauseButton}));
      this._pauseButton.addListener("pointerup", this._genericFlow.bind(this, "pause"));
      replay_button.addListener("pointerup", this._genericFlow.bind(this, "replay_game"));
      resume_button.addListener("pointerup", this._genericFlow.bind(this, "resume"));
      exit_button.addListener("pointerup", async () => {
        SDKManager.quitGame = true;
        // this._showLoadingScreen(true);
        // if (await FBInstantManager.showInterstitialAd()) {
        //   this._showLoadingScreen(false);
          this._goToMenuScene();
        // }
      });
    }
  }

  private _createMuteButton() {
    this._muteButton = this.add.image(0, 0, "assets", "mute_off_button");
    this._muteButton.setPosition(this._pauseButton.x - (this._muteButton.width * 1.5), this._pauseButton.y);

    this._muteButton.setInteractive();
    this._muteButton.addListener("pointerup", this._genericFlow.bind(this, "mute_toggle"));
  }

  private _createSDPauseFlow() {
    let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;

    // containers
    this._pauseMenuContainer = this.add.container(w2, h2);
    this._pauseMenuContainer.setDepth(40);

    // the bars
    let rectangle = this.add.rectangle(0, 0, window.constants.BASE_WIDTH, window.constants.BASE_HEIGHT, 0x000000, 0.85);
    let fontSize = (window.constants.HD_FLAG) ? 40 : 8;
    //text
    this._pauseButton = this.add.image(0, 0, "button");
    let button2 = this.add.image(0, 0, "button");
    if (window.constants["HD_FLAG"]) {
      this._pauseButton.setScale(3);
    } else {
      this._pauseButton.setScale(0.7);
    }
    let button3 = this.add.image(0, 0, "button");
    let buttWidth = Math.floor(this._pauseButton.width * 0.55 * this._pauseButton.scaleX), buttHeight = Math.floor(this._pauseButton.height * 0.55 * this._pauseButton.scaleY);
    this._pauseButton.setPosition(window.constants["BASE_WIDTH"] - buttWidth, window.constants["BASE_HEIGHT"] - buttHeight);
    button2.setPosition(buttWidth - w2, h2 - buttHeight);
    button3.setPosition(w2 - buttWidth, h2 - buttHeight);

    button2.setScale(0.7);
    button3.setScale(0.7);


    this._pauseText = this.add.text(0, 0, "PAUSE", { fontSize: fontSize, fontFamily: "font_2" });
    let text2 = this.add.text(0, 0, "SOUND (ON/OFF)", { fontSize: fontSize, fontFamily: "font_2" });
    let text3 = this.add.text(0, 0, "RESUME", { fontSize: fontSize, fontFamily: "font_2" });

    this._pauseText.setOrigin(0.5, 0.5);
    text2.setOrigin(0.5, 0.5);
    text3.setOrigin(0.5, 0.5);

    this._pauseText.setPosition(this._pauseButton.x, this._pauseButton.y);
    text2.setPosition((text2.width * 0.6) - w2, button2.y);
    text3.setPosition(button3.x, button3.y);

    // adding assets to container
    this._pauseMenuContainer.add([rectangle, button2, button3, text2, text3,]);
    this._handleInputListeners("keyup", this._onNormalHudScreenKeyPress, true);
    this._setPauseScreenVisibility(false);

    this._transitionBanner = this.add.image(w2, h2, "menu_banner");
    this._transitionBanner.setScale(0.87);
    this._transitionBanner.setDepth(50);
    this._transitionBanner.setVisible(false);


    // set touch events
    if (window.constants["HD_FLAG"]) {
      this._pauseText.setInteractive();
      text2.setInteractive();
      text3.setInteractive();
      // this._pauseText.addListener("pointerdown", this._onButtonDown.bind(this, {text: this._pauseText, button: this._pauseButton}));
      this._pauseText.addListener("pointerup", this._onPauseButtonPress, this);
      text2.addListener("pointerup", this._genericFlow.bind(this, "mute_toggle"));
      text3.addListener("pointerup", this._onPauseToResume, this);
    }
  }

  private healthBarWidget = null;

  private _createSDHudBars() {
    let health = this.textures.getFrame("assets", 'health_bar_icon');
    let coin = this.textures.getFrame("assets", 'coin');
    let life = this.textures.getFrame('lives');

    this._pointsIcon = this.add.image(window.constants["BASE_WIDTH"] - (coin.width * 2.5), coin.height * 1.6, "assets", 'points_bar_icon');
    // this._pointsIcon.setScale(2, 2);
    this._healthBarIcon = this.add.image(coin.width, (health.height), "assets", 'health_bar_icon')
    this._livesIcon = this.add.image(coin.width + 10, (life.height) * 1.8, 'lives')
    this._livesIcon.setScale(0.7);
    let fontSize = (window.constants.HD_FLAG) ? 50 : 12;
    // let fontSize = 12;
    // create bitmap texts

    this.bitmapTexts[0] = this.add.text(
      window.constants["BASE_WIDTH"] - (coin.width * 1.1),
      coin.height * 1.6,
      `${this.registry.get("points")}`,
      { fontSize: fontSize, fontFamily: "font_2" },
    );
    this.bitmapTexts[1] = this.add.text(
      health.width * 1.75,
      health.height * 1.45,
      "100%",
      { fontSize: fontSize * 0.8, fontFamily: "font_2" },
    );
    this.bitmapTexts[2] = this.add.text(
      health.width * 1.7,
      health.height * 2.5,
      " X " + `${this._lives}`,
      { fontSize: fontSize, fontFamily: "font_2" },
    );

    this.bitmapTexts[0].setOrigin(0.5, 0.5);
    this.bitmapTexts[1].setOrigin(0.5, 0.5);
    this.bitmapTexts[2].setOrigin(0.5, 0.5);
    // this.bitmapTexts[1].setOrigin(0.5, 0.5);

    this.bitmapTexts[1].visible = false;

    this._livesIconTween = this.add.tween({
      targets: this._livesIcon,
      scale: { from: 0.65, to: 0.9 },
      ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
      duration: 100,
      repeat: 0,            // -1: infinity
      yoyo: true
    });

    this._healthIconTween = this.add.tween({
      targets: this._healthBarIcon,
      scale: { from: 1, to: 1.3 },
      ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
      duration: 100,
      repeat: 0,            // -1: infinity
      yoyo: true
    });

    this._pointsIconTween = this.add.tween({
      targets: this._pointsIcon,
      scale: { from: 1, to: 1.3 },
      ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
      duration: 150,
      repeat: 0,            // -1: infinity
      yoyo: true
    });

    let healthBarWidgetTexture = this.textures.getFrame("assets", 'timer_bar');
    this.healthBarWidget = new InfoBar(this, null, 100, healthBarWidgetTexture.width, healthBarWidgetTexture.height, "assets", 'timer_bar', false, 325, 110);
    this.healthBarWidget.start();
  }

  private highScoreText: any = null;
  private highScoreTextTween: Phaser.Tweens.Tween = null;

  private _createGameOverScreen() {
    // console.log(" game over screen ");

    let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;
    let bar = this.textures.getFrame("assets", "game_over");
    let customY = 300;

    let replayButton = this.add.image(0, 0, "replay_button");
    let exitButton = this.add.image(0, 0, "exit_button");
    // let tournamentButton = this.add.image(0, 0, "tournament");
    // let shareButton = this.add.image(0, 0, "share_button");
    // let friendsButton = this.add.image(0, 0, "friends_button");

    // containers
    this._gameOverContainer = this.add.container(w2, h2);
    this._gameOverContainer.setDepth(30);
    // let dataContainer = this.add.container(0, 0);

    // the bars
    // let gameOverBar = this.add.image(0, 0, "assets", "game_over");
    // gameOverBar.alpha = 0;
    // gameOverBar.setScale(window.constants["BASE_WIDTH"] / gameOverBar.width);


    // assets
    let coin = this.add.image(- Math.floor(bar.width * 0.2), Math.floor(bar.height * 0.02), "assets", "coin");
    coin.setScale(1.3)



    let fontSize = (window.constants.HD_FLAG) ? 63 : 14;

    //text
    let text1 = this.add.text(0, - Math.floor(bar.height * 0.5), "Game Over", { fontSize: fontSize * 1.7, fontFamily: "font_3" });
    let text2 = this.add.text(0, - Math.floor(bar.height * 0.2), "Score", { fontSize: fontSize, fontFamily: "font_2" });
    text2.setVisible(false);
    // let tapText = (window.constants["HD_FLAG"] && true) ? "tap to restart" : " PRESS   \n\nTO RESTART";
    this.highScoreText = this.add.text(0, Math.floor(bar.height * 0.36), "Highscore 0", { fontSize: fontSize, fontFamily: "font_2", color: "#a3a3a3" });
    this._finalScore = this.add.text(Math.floor(bar.width * 0.05), Math.floor(bar.height * 0.01), "999", { fontSize: fontSize * 1.3, fontFamily: "font_2" });
    text1.setOrigin(0.5, 0.5);
    text2.setOrigin(0.5, 0.5);
    this.highScoreText.setOrigin(0.5, 0.5);

    text1.setPosition(0, (- (text2.height * 3)) + customY)
    text2.setPosition(0, (-(text2.height)) + customY);
    this.highScoreText.setPosition(0, this.highScoreText.height * 6.5);
    this._finalScore.setPosition(coin.width * 0.5, (-(coin.height * 0.5)) + customY);
    coin.setPosition(-(coin.width * 1.25), (-(coin.height * 0.5)) + customY);

    replayButton.setPosition(-200, 650);
    exitButton.setPosition(200, 650);
    // tournamentButton.setPosition(300, 900);
    // tournamentButton.setScale(0.5, 0.5);
    // friendsButton.setPosition(200, 830);
    // friendsButton.setScale(1.3, 1.3);
    // shareButton.setPosition(-200, 830);
    // shareButton.setScale(0.9, 0.9);

    this._finalScore.setOrigin(0.5, 0.5);

    this.highScoreTextTween = this.add.tween({
      targets: this.highScoreText,
      scale: { "from": 1, "to": 0.9 },
      ease: "Linear",
      duration: 400,
      delay: 100,
      repeat: -1,
      yoyo: true
    });
    this.highScoreTextTween.stop(0);

    // let text3border = this.add.rectangle(text3.x, text3.y, text3.width * 1.2, text3.height * 1.2, null, 0);
    // text3border.setStrokeStyle(5, 0x39ff14, 1);
    // adding assets to container
    // dataContainer.add([rectangle,text1, text2, text3, coin, this._finalScore]);// gameOverBar, 
    let rectangle = this.add.image(0, 260, "bg_panel");
    // let rectangle = this.add.rectangle(0, customY - 100, window.constants.BASE_WIDTH, Math.floor(text1.y * 7.5), 0x000000, 0.7);
    // gameOverBar.height = rectangle.height;
    // gameOverBar.width = rectangle.width;
    // gameOverBar.setPosition(rectangle.x, rectangle.y);

    // if (!window.constants["HD_FLAG"]) {
    //   let centerIcon = this.add.sprite(0, 0, "dpad_press");
    //   centerIcon.setFrame(1);
    //   centerIcon.setScale(0.5);
    //   centerIcon.setPosition(centerIcon.width * centerIcon.scaleX, Math.floor((bar.height * 0.36) - (centerIcon.height * centerIcon.scaleY * 0.67)));
    //   dataContainer.add(centerIcon);
    // }
    // this._gameOverContainer.add(rectangle);
    // this._gameOverContainer.add([rectangle,text1, text2, text3, coin, this._finalScore, text3border]);

    replayButton.setInteractive();
    replayButton.on("pointerup", function () {
      this._genericFlow("replay_game");
    }, this);

    exitButton.setInteractive();
    exitButton.on("pointerup", function () {
      this._goToMenuScene();
    }, this);

    // tournamentButton.setInteractive();
    // tournamentButton.on("pointerup", function () {
    //   console.log("fb tournament");
    //   FBInstantManager.createTournament();
    // }, this);

    // friendsButton.setInteractive();
    // friendsButton.on("pointerup", function () {
    //   // console.log("fb friends, ", this._points);
    //   // FBInstantManager.inviteFriend(`${FBInstant.player.getName()} wants you to join them in Rampage Road! Can you beat their score of ${this._points}?`)
    // }, this);

    // shareButton.setInteractive();
    // shareButton.on("pointerup", function () {
    //   // console.log("fb share, ", this._points);
    //   // await FBInstant.postSessionScoreAsync(score);
    //   // FBInstant.postSessionScoreAsync(this._points);
    //   // FBInstantManager.shareAsPost(this._points);
    // }, this);

    this._gameOverContainer.add([rectangle, text1, text2, this.highScoreText, coin, this._finalScore, replayButton, exitButton]); //, shareButton, friendsButton

    // tween
    if (this._gameOverTween) {
      this.tweens.remove(this._gameOverTween);
    }
    this._gameOverTween = this.add.tween({
      targets: this._gameOverContainer,
      y: { from: -window.constants["BASE_WIDTH"], to: (h2 * 0.5) },
      ease: Phaser.Math.Easing.Back.InOut,
      duration: 300,
      repeat: 0,
      yoyo: false
    })
    this._gameOverTween.stop();
    this._setEndScreenVisibility(false);
  }

  private playerProfilePic: Phaser.GameObjects.Image[] = [];
  private playerProfilePosY: number = 650;
  private profilePosY: number = 800;
  // private _createTournamentGameOverScreen() {
  //   let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;

  //   // containers
  //   this._tournamentGameOverContainer = this.add.container(w2, h2);
  //   this._tournamentGameOverContainer.setDepth(30);

  //   //text
  //   let text1 = this.add.text(0, -480, "tournament", { fontSize: "70px", fontFamily: "font_3" });
  //   let tournamentEndText = this.add.text(0, -330, `ends on`, { fontSize: "30px", fontFamily: "font_3" });
  //   tournamentEndText.setOrigin(0.5, 0.5);
  //   tournamentEndText.text = "Ends on " + FBInstantManager.tournamentEndDate;
  //   let rectangle = this.add.image(0, -30, "tournament_panel");
  //   // rectangle.setScale(2);
  //   let replayButton = this.add.image(0, 0, "replay_button");
  //   let exitButton = this.add.image(0, 0, "exit_button");
  //   let shareButton = this.add.image(0, 0, "share_button");
  //   let friendsButton = this.add.image(0, 0, "friends_button");

  //   rectangle.setOrigin(0.5, 0.5);
  //   text1.setOrigin(0.5, 0.5);

  //   replayButton.setPosition(-400, 625);
  //   // replayButton.setScale(0.8, 0.8);
  //   exitButton.setPosition(-130, 625);
  //   // exitButton.setScale(0.8, 0.8);
  //   friendsButton.setPosition(130, 625);
  //   // friendsButton.setScale(0.8, 0.8);
  //   shareButton.setPosition(400, 625);
  //   // shareButton.setScale(0.8, 0.8);

  //   this._tournamentGameOverContainer.add([rectangle, text1, tournamentEndText, replayButton, exitButton, shareButton, friendsButton]);

  //   this.loadPlayersProfilePic();

  //   let playerDetails = FBInstantManager.playerLeaderboardEntry.getPlayer();

  //   let playerBg: Phaser.GameObjects.Image[] = [];
  //   let playerRank: Phaser.GameObjects.Text[] = [];
  //   let playerScore: Phaser.GameObjects.Text[] = [];
  //   let playerName: Phaser.GameObjects.Text[] = [];

  //   let playerPosY = tournamentEndText.y + 100;
  //   this.playerProfilePosY = playerPosY;
  //   playerBg[0] = this.add.image(0, playerPosY, "players_rank_bg");
  //   playerBg[0].setOrigin(0.5);
  //   // playerRank[0] = new PlayerRank(this, w2 - 750, playerPosY, "1", { fontSize: "40px", fontFamily: "font_2" });
  //   // playerName[0] = new PlayerName(this, w2 - 620, playerPosY - 20, "hema", { fontSize: "40px", fontFamily: "font_2" });
  //   // playerScore[0] = new PlayerScore(this, w2 - 270, playerPosY, "100", { fontSize: "40px", fontFamily: "font_2" });
  //   playerRank[0] = new PlayerRank(this, w2 - 750, playerPosY, `${FBInstantManager.playerLeaderboardEntry.getRank()}`, { fontSize: "40px", fontFamily: "font_2" });
  //   playerName[0] = new PlayerName(this, w2 - 620, playerPosY - 20, playerDetails.getName(), { fontSize: "40px", fontFamily: "font_2" });
  //   playerScore[0] = new PlayerScore(this, w2 - 270, playerPosY, `${FBInstantManager.playerLeaderboardEntry.getScore()}`, { fontSize: "40px", fontFamily: "font_2" });
  //   this._tournamentGameOverContainer.add(playerBg[0]);
  //   this._tournamentGameOverContainer.add(playerRank[0]);
  //   this._tournamentGameOverContainer.add(playerName[0]);
  //   this._tournamentGameOverContainer.add(playerScore[0]);

  //   // let posY = (window.constants["BASE_HEIGHT"] / 2) - 750;
  //   let posY = playerPosY + 150;
  //   this.profilePosY = posY;

  //   playerBg[1] = this.add.image(0, posY, "players_rank_bg");
  //   playerBg[1].setOrigin(0.5);
  //   playerBg[1].visible = false;
  //   playerBg[2] = this.add.image(0, posY + 125, "players_rank_bg");
  //   playerBg[2].setOrigin(0.5);
  //   playerBg[2].visible = false;
  //   playerBg[3] = this.add.image(0, posY + 250, "players_rank_bg");
  //   playerBg[3].setOrigin(0.5);
  //   playerBg[3].visible = false;
  //   playerBg[4] = this.add.image(0, posY + 375, "players_rank_bg");
  //   playerBg[4].setOrigin(0.5);
  //   playerBg[4].visible = false;
  //   playerBg[5] = this.add.image(0, posY + 500, "players_rank_bg");
  //   playerBg[5].setOrigin(0.5);
  //   playerBg[5].visible = false;

  //   FBInstantManager.allLeaderboardEntries.forEach((player, index) => {
  //     if (index > 4)
  //       return;

  //     // console.log(FBInstantManager.allLeaderboardEntries.length);
  //     let otherPlayerDetails = player.getPlayer();
  //     playerBg[index + 1].visible = true;
  //     if (playerDetails.getName() == otherPlayerDetails.getName()) {
  //       playerRank[index + 1] = new PlayerRank(this, w2 - 750, posY + (125 * index), `${FBInstantManager.playerLeaderboardEntry.getRank()}`, { fontSize: "40px", fontFamily: "font_2" });
  //       playerName[index + 1] = new PlayerName(this, w2 - 620, (posY - 20) + (125 * index), playerDetails.getName(), { fontSize: "40px", fontFamily: "font_2" });
  //       playerScore[index + 1] = new PlayerScore(this, w2 - 270, posY + (125 * index), `${FBInstantManager.playerLeaderboardEntry.getScore()}`, { fontSize: "40px", fontFamily: "font_2" });
  //     } else {
  //       playerRank[index + 1] = new PlayerRank(this, w2 - 750, posY + (125 * index), `${player.getRank()}`, { fontSize: "40px", fontFamily: "font_2" });
  //       playerName[index + 1] = new PlayerName(this, w2 - 620, (posY - 20) + (125 * index), `${otherPlayerDetails.getName()}`, { fontSize: "40px", fontFamily: "font_2" });
  //       playerScore[index + 1] = new PlayerScore(this, w2 - 270, posY + (125 * index), `${player.getScore()}`, { fontSize: "40px", fontFamily: "font_2" });
  //     }
  //     this._tournamentGameOverContainer.add(playerBg[index + 1]);
  //     this._tournamentGameOverContainer.add(playerRank[index + 1]);
  //     this._tournamentGameOverContainer.add(playerName[index + 1]);
  //     this._tournamentGameOverContainer.add(playerScore[index + 1]);
  //   });

  //   // for (let i = 0; i < 5; i++) {
  //   //   playerBg[i + 1].visible = true;
  //   //   playerRank[i + 1] = new PlayerRank(this, w2 - 750, posY + (125 * i), "1", { fontSize: "40px", fontFamily: "font_2" });
  //   //   playerName[i + 1] = new PlayerName(this, w2 - 620, (posY - 20) + (125 * i), "hema", { fontSize: "40px", fontFamily: "font_2" });
  //   //   playerScore[i + 1] = new PlayerScore(this, w2 - 270, posY + (125 * i), "100", { fontSize: "40px", fontFamily: "font_2" });
  //   //   this._tournamentGameOverContainer.add(playerBg[i + 1]);
  //   //   this._tournamentGameOverContainer.add(playerRank[i + 1]);
  //   //   this._tournamentGameOverContainer.add(playerName[i + 1]);
  //   //   this._tournamentGameOverContainer.add(playerScore[i + 1]);
  //   // }

  //   replayButton.setInteractive();
  //   replayButton.on("pointerup", function () {
  //     this.clearTextures();
  //     this._tournamentGameOverContainer.setVisible(false);
  //     this._tournamentGameOverContainer.setActive(false);
  //     this._tournamentGameOverContainer.setDepth(30);
  //     this._tournamentGameOverContainer = null;
  //     this._genericFlow("replay_game");
  //   }, this);

  //   exitButton.setInteractive();
  //   exitButton.on("pointerup", function () {
  //     this.clearTextures();
  //     this._tournamentGameOverContainer.setVisible(false);
  //     this._tournamentGameOverContainer.setActive(false);
  //     this._tournamentGameOverContainer.setDepth(30);
  //     this._tournamentGameOverContainer = null;
  //     this._goToMenuScene();
  //   }, this);

  //   friendsButton.setInteractive();
  //   friendsButton.on("pointerup", function () {
  //     // console.log("fb friends, ", this._points);
  //     // FBInstantManager.inviteFriend(`${FBInstant.player.getName()} wants you to join them in Rampage Road! Can you beat their score of ${this._points}?`)
  //   }, this);

  //   shareButton.setInteractive();
  //   shareButton.on("pointerup", function () {
  //     // console.log("fb share, ", this._points);
  //     // FBInstant.postSessionScoreAsync(this._points);
  //   }, this);

  //   // tween
  //   if (this._tournamentGameOverTween) {
  //     this.tweens.remove(this._tournamentGameOverTween);
  //   }
  //   this._tournamentGameOverTween = this.add.tween({
  //     targets: this._tournamentGameOverContainer,
  //     y: { from: -window.constants["BASE_WIDTH"], to: (h2 * 0.6) },
  //     ease: Phaser.Math.Easing.Back.InOut,
  //     duration: 300,
  //     repeat: 0,
  //     yoyo: false
  //   })
  //   this._tournamentGameOverTween.stop();

  //   this._showLoadingScreen(false);
  //   this._tournamentGameOverContainer.setScale(0.8);
  //   this._tournamentGameOverContainer.setVisible(true);
  //   this._tournamentGameOverContainer.setActive(true);
  //   this._tournamentGameOverContainer.setDepth(30);
  // }

  // loadPlayersProfilePic() {
  //   let playerDetails = FBInstantManager.playerLeaderboardEntry.getPlayer();
  //   this.load.image(`player-LB-profile-pic`, playerDetails.getPhoto());
  //   this.load.once(`filecomplete-image-player-LB-profile-pic`, this.getPlayerPhoto, this);
  //   // console.log(playerDetails.getName());

  //   FBInstantManager.allLeaderboardEntries.forEach((player, index) => {
  //     if (index > 4)
  //       return;

  //     let otherPlayerDetails = player.getPlayer();

  //     if (playerDetails.getName() == otherPlayerDetails.getName()) {
  //       this.load.image(`player-LB-profile-pic-${index}`, playerDetails.getPhoto());
  //       this.load.once(`filecomplete-image-player-LB-profile-pic-${index}`, this.getPlayerPhoto, this);
  //     } else {
  //       this.load.image(`player-LB-profile-pic-${index}`, otherPlayerDetails.getPhoto());
  //       this.load.once(`filecomplete-image-player-LB-profile-pic-${index}`, this.getPlayerPhoto, this);
  //     }
  //     // console.log(otherPlayerDetails.getName());
  //   });
  //   this.load.start();
  // }

  private profilePosX: number = (window.constants["BASE_WIDTH"] / 2) - 670;
  getPlayerPhoto(key: any) {
    // console.log(key);
    switch (key) {
      case "player-LB-profile-pic":
        this.playerProfilePic[0] = new PlayerImage(this, this.profilePosX, this.playerProfilePosY, "player-LB-profile-pic");
        this._tournamentGameOverContainer.add(this.playerProfilePic[0]);
        break;
      case "player-LB-profile-pic-0":
        this.playerProfilePic[1] = new PlayerImage(this, this.profilePosX, this.profilePosY, "player-LB-profile-pic-0");
        this._tournamentGameOverContainer.add(this.playerProfilePic[1]);
        break;
      case "player-LB-profile-pic-1":
        this.playerProfilePic[2] = new PlayerImage(this, this.profilePosX, this.profilePosY + 125, "player-LB-profile-pic-1");
        this._tournamentGameOverContainer.add(this.playerProfilePic[2]);
        break;
      case "player-LB-profile-pic-2":
        this.playerProfilePic[3] = new PlayerImage(this, this.profilePosX, this.profilePosY + 250, "player-LB-profile-pic-2");
        this._tournamentGameOverContainer.add(this.playerProfilePic[3]);
        break;
      case "player-LB-profile-pic-3":
        this.playerProfilePic[4] = new PlayerImage(this, this.profilePosX, this.profilePosY + 375, "player-LB-profile-pic-3");
        this._tournamentGameOverContainer.add(this.playerProfilePic[4]);
        break;
      case "player-LB-profile-pic-4":
        this.playerProfilePic[5] = new PlayerImage(this, this.profilePosX, this.profilePosY + 500, "player-LB-profile-pic-4");
        this._tournamentGameOverContainer.add(this.playerProfilePic[5]);
        break;
    }
  }

  clearTextures() {
    this.textures.remove("player-LB-profile-pic");
    for (let i = 0; i < 5; i++) {
      // console.log("clear texture ", i);
      this.textures.remove(`player-LB-profile-pic-${i}`);
    }
  }

  private _createNoAdScreen() {
    this.anims.create({
      key: "center_press_anim",
      frames: this.anims.generateFrameNumbers("center_press", {
        start: 0,
        end: 1,
      }),
      frameRate: 5,
      repeat: -1,
      showOnStart: true
    })

    let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;
    this._noAdContainer = this.add.container(w2, h2);
    this._noAdContainer.setDepth(60);

    let rectangle = this.add.rectangle(0, 0, window.constants.BASE_WIDTH, window.constants.BASE_HEIGHT, 0x000000, 0.85);
    let fontSize = (window.constants["HD_FLAG"]) ? 60 : 14;

    let warning = this.add.sprite(0, 0, "warning_mini");
    warning.setPosition(0, -warning.height);

    //text
    let text1 = this.add.text(0, 0, "NO ADS AVAILABLE", { fontSize: fontSize, fontFamily: "font_2", color: "#ff5c33" });
    text1.setOrigin(0.5, 0.5);

    this._noAdContainer.add([rectangle, text1, warning]);
    this._centerPressButton = null;

    if (!window.constants["HD_FLAG"]) {
      this._centerPressButton = this.add.sprite(0, 0, "center_press");
      this._centerPressButton.setScale(0.7);
      this._centerPressButton.setPosition(0, this._centerPressButton.height);

      this._centerPressButton.play("center_press_anim");
      this._noAdContainer.add(this._centerPressButton);
    }


    this._setNoAdScreenVisibility(false);

    if (window.constants["HD_FLAG"]) {
      rectangle.setInteractive();
      rectangle.addListener("pointerup", this._setNoAdScreenVisibility.bind(this, false));
    }
  }

  private _adText: string = "WATCH AN AD";
  private _adScreenMessage: Phaser.GameObjects.Text;

  private _createAdScreen() {
    let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;

    // containers
    this._adPanelContainer = this.add.container(w2, h2);
    this._adPanelContainer.setDepth(40);
    let dataContainer = this.add.container(0, 0);

    // the bars
    let fontSize = (window.constants["HD_FLAG"]) ? 60 : 14;

    //text
    this._adScreenMessage = this.add.text(0, 0, this._adText, { fontSize: fontSize, fontFamily: "font_2", align: "center" });

    this._adScreenMessage.setOrigin(0.5, 0.5);
    // let watchAdButton = this.add.image(0, 0, "assets", "resume_button");
    let yesButton = this.add.image(0, 0, "ad_yes_button");
    let noButton = this.add.image(0, 0, "ad_no_button");

    this._adScreenMessage.setPosition(this._adScreenMessage.x, this._adScreenMessage.y - 150);
    yesButton.setPosition(- yesButton.width, this._adScreenMessage.height + Math.floor(yesButton.height * 0.5) - 80);
    noButton.setPosition(noButton.width, this._adScreenMessage.height + Math.floor(noButton.height * 0.5) - 80);

    let rectangle = this.add.image(0, -20, "bg_panel");
    // let rectangle = this.add.rectangle(0, 0, window.constants.BASE_WIDTH, Math.floor((this._adScreenMessage.y - yesButton.y) * 2.5), 0x000000, 0.7);

    // adding assets to container
    dataContainer.add([this._adScreenMessage, yesButton, noButton]);
    this._adPanelContainer.add(rectangle);
    this._adPanelContainer.add(dataContainer);

    // adding touch events
    if (window.constants["HD_FLAG"]) {
      // text3.setInteractive();
      // text4.setInteractive();
      yesButton.setInteractive();
      noButton.setInteractive();

      // text3.on("pointerup", this._setNoAdScreenVisibility.bind(this, true)); // watch ad
      // text4.on("pointerup", this._onAdScreenCancel, this); // quit game

      yesButton.on("pointerup", function () {

        this.isRewardedAD = true;
        this._lives = 1;
        this._genericFlow("show_ad");
      }, this);
      noButton.on("pointerup", async function () {
        SDKManager.quitGame = false;
        // this._showLoadingScreen(true);
        // if (await FBInstantManager.showInterstitialAd()) {
        //   this._showLoadingScreen(false);
          this._genericFlow("reward_fail");
        // }
      }, this);
    }
    this._setAdScreenVisibility(false);
  }

  private _createReSpawningScreen() {
    let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;

    // containers
    this._reSpawningContainer = this.add.container(w2, h2);
    this._reSpawningContainer.setDepth(60);

    let rectangle = this.add.rectangle(0, 0, window.constants.BASE_WIDTH, window.constants.BASE_HEIGHT, 0x000000, 0.9);
    let fontSize = 14;

    //text
    let text1 = this.add.text(0, 0, "Loading\nReward Turn ...", { fontSize: fontSize, fontFamily: "font_2", color: "#ff5c33", align: "center" });

    text1.setOrigin(0.5, 0.5);
    text1.setPosition(0, -(text1.height * 1.5))

    // adding assets to container
    this._reSpawningContainer.add(rectangle);
    this._reSpawningContainer.add(text1);
    this._hideReSpawnScreen(true);
  }

  // ============================ code for creation of screens end ============================

  // ============================ code for keypress callbacks start ============================


  private _onNormalHudScreenKeyPress(event) {
    if (!this._adPanelContainer.visible) {
      if (event.key == "SoftRight" || event.which == 48) {
        // pause
        this._handleInputListeners("keyup", this._onNormalHudScreenKeyPress, false);
        this.scene.pause("GameScene");
        this._setPauseScreenVisibility(true);
      }
    }
  }

  private _onPauseScreenKeyPress(event) {
    if (event.key == "SoftLeft" || event.which == 37) {
      // go to menu
      this._setPauseScreenVisibility(false);
      this._handleInputListeners("keyup", this._onPauseScreenKeyPress, false);
      this._goToMenuScene();
    } else if (event.key == "SoftRight" || event.which == 39) {
      // resume
      this._setPauseScreenVisibility(false);
      this._handleInputListeners("keyup", this._onPauseScreenKeyPress, false);
      this.scene.resume("GameScene");
    }
  }

  private _onNoAdScreenKeyPress(e) {
    if (e.which == 13) {
      this._setNoAdScreenVisibility(false);
    }
  }

  private _onAdScreenKeyPress(event) {
    if (event.key == "SoftLeft" || event.which == 37) {
      console.log("Going for Reward Ad");
      try {
        this._setNoAdScreenVisibility(true);
      } catch (e) {
        console.log("Reward Ad is not ready");
        this._setNoAdScreenVisibility(true);
      }
      // this._onRewardSuccess();
    } else if (event.key == "SoftRight" || event.which == 39) {
      console.log("Not going for Reward Ad");
      // this._onRewardFail();
      this._genericFlow("reward_fail");
    }
  }

  // ============================ code for keypress callbacks end ============================

  // ============================ code for pointer down and up callbacks start ============================

  // ============================ code for pointer down and up callbacks start ============================
  private _onButtonDown(button) {

  }

  private _onAdScreenCancel() {
    this._setPauseScreenVisibility(false);
    this._setAdScreenVisibility(false);
    this._setEndScreenVisibility(true);
  }

  private _onPauseToMenu() {
    this._setPauseScreenVisibility(false);
    this._goToMenuScene();
  }

  private _onPauseToResume() {
    if (this.game.sound.volume == 1) {
      this.game.sound.mute = false;
    }
    this._setPauseScreenVisibility(false);
    this.scene.resume("GameScene");
  }

  private _onPauseButtonPress() {
    window.game.sound.mute = true;
    this.scene.pause("GameScene");
    this._setPauseScreenVisibility(true);
  }

  // ============================ code for setting visibility of scene objects and screens end ============================

  private _setPauseButtonVisibility(show) {
    if (this._pauseButton) {
      if (show) {
        if (!this._adPanelContainer.visible && !this._gameOverContainer.visible && !this._noAdContainer.visible) {
          // this._pauseText.setVisible(true);
          this._pauseButton.setVisible(true);
          if (this._muteButton) {
            this._muteButton.setVisible(true);
          }
          this._handleInputListeners("keyup", this._onNormalHudScreenKeyPress, false);
          this._handleInputListeners("keyup", this._onNormalHudScreenKeyPress, true);
        }
      } else {
        // this._pauseText.setVisible(false)
        if (this._muteButton) {
          this._muteButton.setVisible(false);
        }
        this._pauseButton.setVisible(false);
        this._handleInputListeners("keyup", this._onNormalHudScreenKeyPress, false);
      }
    }
  }

  private _setPauseScreenVisibility(show) {
    this._pauseMenuContainer.setVisible(show);
    if (show) {
      this._setPauseButtonVisibility(false);
      this._handleInputListeners("keyup", this._onPauseScreenKeyPress, false);
      this._handleInputListeners("keyup", this._onPauseScreenKeyPress, true);
    } else {
      this._setPauseButtonVisibility(true);
      this._handleInputListeners("keyup", this._onNormalHudScreenKeyPress, true);
      this._handleInputListeners("keyup", this._onPauseScreenKeyPress, false);
    }
  }

  private _setNoAdScreenVisibility(show) {
    this._noAdContainer.setVisible(show);
    if (show) {
      this._setAdScreenVisibility(false);
      this._setEndScreenVisibility(false);
      this._handleInputListeners("keyup", this._onNoAdScreenKeyPress, false);
      this._handleInputListeners("keyup", this._onNoAdScreenKeyPress, true);
      if (this._centerPressButton) {
        this._centerPressButton.anims.play("center_press_anim");
      }
      this._setPauseButtonVisibility(false);
    } else {
      this._handleInputListeners("keyup", this._onNoAdScreenKeyPress, false);
      if (this._centerPressButton) {
        this._centerPressButton.anims.stop();
      }
      this._setAdScreenVisibility(true);
    }
  }

  private _setAdScreenVisibility(show: boolean) {
    show = (!show || (this.registry.get("health") > 0)) ? false : true;
    this._adPanelContainer.setVisible(show);
    this._adPanelContainer.setActive(show);
    this._gameOverContainer.setDepth(30);
    if (show) {
      this._handleInputListeners("keyup", this._onAdScreenKeyPress, false);
      this._handleInputListeners("keyup", this._onAdScreenKeyPress, true);
      // hide pause
      this._setPauseButtonVisibility(false);
      // this._adTimerTween.play();
    }
    else {
      // show pause
      // this._adTimerTween.stop();
      this._handleInputListeners("keyup", this._onAdScreenKeyPress, false);
      this._setPauseButtonVisibility(true);
    }
  }

  private _setEndScreenVisibility(show: boolean) {
    // show = (!show || (this.registry.get("health") > 0)) ? false : true;
    show = !!show;
    this._gameOverContainer.setVisible(false);
    this._gameOverContainer.setActive(false);
    this._gameOverContainer.setDepth(20);
    if (show) {
      console.log("Posting Score: " + this._points);
      try {
        // this._handleInputListeners("keyup", this._restartGame, false);
        // this._handleInputListeners("keyup", this._restartGame, true);
        this._gameOverTween.restart();
        this._finalScore.setText(this._points + "");
        // hide pause button
        this._setPauseButtonVisibility(false);
      } catch (e) {
        // this._handleInputListeners("keyup", this._restartGame, false);
        // this._handleInputListeners("keyup", this._restartGame, true);
        this._gameOverTween.restart();
        this._finalScore.setText(this._points + "");
        // hide pause button
        this._setPauseButtonVisibility(false);
      }
    } else {
      // show pause button
      this._handleInputListeners("keyup", this._restartGame, false);
      this._setPauseButtonVisibility(true);
    }
  }

  private showWreckedText() {
    let car = this.registry.get("car_wrecked");
    switch (car) {
      case 1: {
        this._wreckedText.start(null, null, "mini boss destroyed");
        break;
      }
      case 2: {
        this._wreckedText.start(null, null, "boss destroyed");
        break;
      }
      default:
      case 0: {
        if (this._lives < 1)
          this._wreckedText.start(null, null, "wrecked");
        else if (this._lives >= 1)
          this._wreckedText.start(null, null, "respawning");
      }
    }
  }

  private _hideReSpawnScreen(hide: boolean) {
    this._reSpawningContainer.setVisible(!hide);
  }

  private _showLoadingScreen(show: boolean = false) {
    this._adWaitingPanelContianer.setVisible(show);
    this._adWaitingPanelContianer.setActive(show);
  }


  // ============================ code for setting visibility of scene objects and screens end ============================

  private _goToMenuScene() {
    this._lives = this.getLives();
    // if (FBInstantManager.isTournament) {
    //   window.gameEvents.off("onTournamentGameOver");
    // }
    this._transitionBanner.setVisible(true);
    this.scene.get("GameScene").events.emit("gameOver");
    this.scene.resume("GameScene");
    let _this = this;
    window.setTimeout(function () {
      SDKManager.canCheckRoadTexture = true;
      _this._cleanUp(false);
      _this.scene.sleep("GameScene");
      _this.scene.sleep("HUDScene");
      _this.scene.switch("MenuScene");
      _this.scene.get("MenuScene").events.emit("MenuResume");
      _this._transitionBanner.setVisible(false);
    }, 1000);
  }

  exitGame() {
    this._showLoadingScreen(false);
    this._goToMenuScene();
  }

  private _onRewardSuccess() {
    this._hideReSpawnScreen(true);
    this.game.setRewardStatus(true);
    this._restartGame({ which: 53 }, true);
    this._handleInputListeners("keyup", this._onAdScreenKeyPress, false);
    this._setEndScreenVisibility(false);
  }

  private _onRewardFail() {
    this._setEndScreenVisibility(true);
    this._handleInputListeners("keyup", this._onAdScreenKeyPress, false);
    this._setAdScreenVisibility(false);
  }

  private _restartGame(e, partialReset: boolean) {
    if (window.constants["TOUCH_FLAG"] || e.which == 53 || e.keyCode == 53 || e.which == 13 || e.keyCode == 13) {
      if (this._tournamentGameOverContainer != null) {
        if (this._gameOverContainer.visible || this._tournamentGameOverContainer.visible || this._adPanelContainer.visible) {
          this._cleanUp(partialReset);
          this.events.emit("resumeGame");
        }
      } else {
        if (this._gameOverContainer.visible || this._adPanelContainer.visible) {
          this._cleanUp(partialReset);
          this.events.emit("resumeGame");
        }
      }
    }
  }

  private _cleanUp(partialReset: boolean) {
    this._setAdScreenVisibility(false);
    this._setEndScreenVisibility(false);
    this._setPauseScreenVisibility(false);
    this._setBloodVisibility(0);
    this.setHealth();
    this.updateLives(true);
    this._livesIconTween.restart();
    if (!partialReset) {
      this._instructionText.visible = true;
      this.time.delayedCall(3000, () => {
        this._instructionText.visible = false;
      });
      this._points = 0;
      window.constants["POINTS"] = [0];
      window.constants["UPDATE_POINTS"] = true;
    }
    this._setPauseButtonVisibility(false);
  }

  private _onTutorialFailure() {
    this._setBloodVisibility(0);
    this.setHealth();
    this.updateLives(true);
  }

  setHealth() {
    switch (window.constants["CAR_CHOOSEN"]) {
      case 0:
        this.registry.set("health", 10);
        break;
      case 1:
        this.registry.set("health", 11);
        break;
      case 2:
        this.registry.set("health", 11);
        break;
      case 3:
        this.registry.set("health", 12);
        break;
      case 4:
        this.registry.set("health", 12);
        break;
      case 5:
        this.registry.set("health", 13);
        break;
      case 6:
        this.registry.set("health", 13);
        break;
    }
  }

  private _onGameBegin() {
    this._setPauseButtonVisibility(true);
  }

  // must be called after creating all the assets for HUD
  private _addEventListeners() {
    const scene = this.scene.get("GameScene");
    scene.events.on("healthChanged", this.updateLives, this);
    scene.events.on("carWrecked", this.showWreckedText, this);
    scene.events.on("tutorialFailed", this._onTutorialFailure, this);
    scene.events.on("GameBegin", this._onGameBegin, this);
    // this.events.on("RewardVideoSeen", this._hideReSpawnScreen, this);
    // this.events.on("RewardSuccess", this._onRewardSuccess, this);
    // this.events.on("RewardFail", this._onRewardFail, this);
    // this.events.on("gotoMenu", this._goToMenuScene, this);
    this.events.on("RewardSuccess", this._genericFlow.bind(this, "reward_success"));
    this.events.on("RewardFail", this._genericFlow.bind(this, "reward_fail"));
    this.events.on("RewardExists", this._genericFlow.bind(this, "reward_exists"));
    this.events.on("RestartGame", this._genericFlow.bind(this, "restart_game"), this);
  }

  private _setBloodVisibility(amount) {
    if (amount > 0) {
      if (!this._blood.visible) {
        this._blood.setVisible(true);
        this._blood.setActive(true);
      }
    } else {
      this._blood.setVisible(false);
      this._blood.setActive(false);
    }
    this._blood.setAlpha(amount);
  }

  private updatePoints() {
    while (window.constants["POINTS"].length) {
      this._points += window.constants["POINTS"].pop();
      this.registry.set("points", this._points);
      this.bitmapTexts[0].setText(this._points + "");
      this._pointsIconTween.restart();
    }
  }

  private onTutoriaCrash() {
    let health = this.registry.get("health");
    if (window.constants["HD_FLAG"]) {
      // this._healthBar.setValue(health);
      let percent = (health / 10) * 100;
      // this.bitmapTexts[1].setText(percent + "%");
      this.healthBarWidget.setValue(percent);
    } else {
      let percent = (health / 10) * 100;
      // this.bitmapTexts[1].setText(percent + "%");
      this.healthBarWidget.setValue(percent);
    }
    this._healthIconTween.restart();
    if (health <= 0) {
      this._setPauseButtonVisibility(false);
      this._setBloodVisibility((window.constants["HD_FLAG"]) ? 1 : 0.7);
    } else if (health < 3) {
      this._setBloodVisibility((window.constants["HD_FLAG"]) ? 0.75 : 0.5)
    } else if (health < 5) {
      this._setBloodVisibility((window.constants["HD_FLAG"]) ? 0.5 : 0.3)
    }
  }

  private updateLives(noEndScreen: boolean) {
    SDKManager.getPlayerFirstTimeMetaData();
    let health = this.registry.get("health");
    if (window.constants["HD_FLAG"]) {
      // this._healthBar.setValue(health);
      let percent = (health / 10) * 100;
      switch (window.constants["CAR_CHOOSEN"]) {
        case 0:
          percent = (health / 10) * 100;
          break;
        case 1:
          percent = (health / 11) * 100;
          break;
        case 2:
          percent = (health / 11) * 100;
          break;
        case 3:
          percent = (health / 12) * 100;
          break;
        case 4:
          percent = (health / 12) * 100;
          break;
        case 5:
          percent = (health / 13) * 100;
          break;
        case 6:
          percent = (health / 13) * 100;
          break;
      }
      // this.bitmapTexts[1].setText(percent + "%");
      this.healthBarWidget.setValue(percent);
      this.bitmapTexts[2].setText(" X " + `${this._lives}`);
    } else {
      let percent = (health / 10) * 100;
      switch (window.constants["CAR_CHOOSEN"]) {
        case 0:
          percent = (health / 10) * 100;
          break;
        case 1:
          percent = (health / 11) * 100;
          break;
        case 2:
          percent = (health / 11) * 100;
          break;
        case 3:
          percent = (health / 12) * 100;
          break;
        case 4:
          percent = (health / 12) * 100;
          break;
        case 5:
          percent = (health / 13) * 100;
          break;
        case 6:
          percent = (health / 13) * 100;
          break;
      }
      // this.bitmapTexts[1].setText(percent + "%");
      this.healthBarWidget.setValue(percent);
      this.bitmapTexts[2].setText(" X " + `${this._lives}`);
    }
    this._healthIconTween.restart();
    if (health <= 0) {
      // if (FBInstantManager.canSetTournamentGameOver) {
      //   FBInstantManager.canSetTournamentGameOver = false;
      //   window.gameEvents.on("onTournamentGameOver", this._createTournamentGameOverScreen.bind(this));
      // }

      // // FBInstantManager.getPlayerFirstTimeMetaData();
      // if (localStorage.getItem("hammerplay_rampageroad_first") == "true") {
      // // if (FBInstantManager.isFirstTime == true) {
      //   // console.log(FBInstantManager.isFirstTime, " tutorial");
      //   this._setPauseButtonVisibility(false);
      //   this._setBloodVisibility((window.constants["HD_FLAG"]) ? 1 : 0.7);
      //   return;
      // }
      if (this._lives <= 1) {
        this._lives -= 1;
        this._setPauseButtonVisibility(false);
        this._setBloodVisibility((window.constants["HD_FLAG"]) ? 1 : 0.7);
        if (!window.constants["TUTORIAL_MODE"] || noEndScreen) {
          // window.game.ms_sdk.checkRewardedVideoAds();
          // window.setTimeout(this._setAdScreenVisibility.bind(this, true), 2000);
          // FBInstantManager.getPlayerFirstTimeMetaData();
          // if (localStorage.getItem("hammerplay_rampageroad_first") == "false") {
          // if (FBInstantManager.isFirstTime == false) {
          if (window.constants["SDK"].adsWatchedCount < window.constants["SDK"].totalAdsCount) {
            this._canRevive = true;
            this._isSkippedRevive = true;
            this._adText = "WATCH AN AD\nTO GET 1 LIFE";
            this._adScreenMessage.setText(this._adText);
            window.setTimeout(this._genericFlow.bind(this, "check_for_ad"), 2000);
            window.constants["SDK"].adsWatchedCount++;
          } else {
            // this._canDoubleScore = true;
            // this._isSkippedRevive = false;
            // this._adText = "WATCH AN AD\nTO DOUBLE THE SCORE";
            // this._adScreenMessage.setText(this._adText);
            // window.setTimeout(this._genericFlow.bind(this, "check_for_ad"), 2000)
            window.setTimeout(this._genericFlow.bind(this, "game_over"), 2000);
            // setTimeout(() => {
            //   window.game.sound.mute = true;
            //   this.checkHighestScore();
            //   window.constants["SDK"].onGameEnd(this._points, this._highestScore);
            // }, 2000);
          }
          // }
        }
      } else if (this._lives > 1) {
        this._setPauseButtonVisibility(false);
        this._setBloodVisibility((window.constants["HD_FLAG"]) ? 1 : 0.7);
        this._lives -= 1;
        setTimeout(() => {
          this._cleanUp(true);
          this.events.emit("resumeGame");
        }, 2000);
      }

    } else if (health < 3) {
      this._setBloodVisibility((window.constants["HD_FLAG"]) ? 0.75 : 0.5)
    } else if (health < 5) {
      this._setBloodVisibility((window.constants["HD_FLAG"]) ? 0.5 : 0.3)
    }
  }

  private async _genericFlow(state: string) {
    switch (state) {
      case "check_for_ad":
        {
          this._onAdScreenCancel();
          this._setAdScreenVisibility(true);
          break;
        }
      case "show_ad":
        {
          window.game.sound.mute = true;
          this.onAdWatch();
          if (this._canRevive) {
            // if (await FBInstantManager.showLifeVideoAd())
              this.onAdClose(true);
            // window.rewardEvent();
          } else if (this._canDoubleScore) {
            // if (await FBInstantManager.showLifeVideoAd())
              this.onAdClose(true);
            // window.rewardEvent();
          }
          // this._genericFlow("reward_success");
          break;
        }
      case "reward_fail":
        {
          this._showLoadingScreen(false);
          setTimeout(() => {
            this.checkHighestScore();
            // window.constants["SDK"].onGameEnd(this._points, this._highestScore);
            this._genericFlow("game_over");
          });
          this._onAdScreenCancel();
          break;
        }
      case "game_over":
        {
          // SDKManager.tournamentGameOver = true;
          this.checkHighestScore();
          this._onAdScreenCancel();
          // if (!FBInstantManager.isTournament) {
            this._showLoadingScreen(false);
            this._gameOverContainer.setVisible(true);
            this._gameOverContainer.setActive(true);
            this._gameOverContainer.setDepth(20);
          // } else {
            // this.time.delayedCall(1000, () => {
            // this._showLoadingScreen(true);
            // this._createTournamentGameOverScreen();
            // this._tournamentGameOverContainer.setVisible(true);
            // this._tournamentGameOverContainer.setActive(true);
            // this._tournamentGameOverContainer.setDepth(30);
            // })
          // }
          SDKManager.getPlayerCoinsMetaData();
          let coins = SDKManager.coins;
          // let coins = +localStorage.getItem("hammerplay_rampageroad_coins");
          coins = coins + this._points
          // localStorage.setItem("hammerplay_rampageroad_coins", coins.toString());
          SDKManager.setPlayerCoinsMetaData(coins);
          this._lives = this.getLives();
          window.constants["SDK"].adsWatchedCount = 1; // Reset to 0 to activate ads.
          // let _this = this;
          // window.setTimeout(function () {
          //   _this._goToMenuScene();
          // }, 5000);
          break;
        }
      case "reward_success":
        {
          if (this.game.sound.volume == 1) {
            this.game.sound.mute = false;
          }
          this.game.setRewardStatus(true);
          this._restartGame({ which: 53 }, true);
          break;
        }
      case "reward_exists":
        {
          this._setAdScreenVisibility(true);
          break;
        }
      case "restart_game":
        {
          this.onRestartGame();
          break;
        }
      case "replay_game":
        {
          this.onRestartGame();
          break;
        }
      case "mute_toggle":
        {
          if (this.game.sound.volume == 0) {
            this._muteButton.setTexture("assets", "mute_off_button");
            this.game.sound.volume = 1;
            this.game.sound.mute = false;
          } else {
            this._muteButton.setTexture("assets", "mute_on_button");
            this.game.sound.volume = 0;
            this.game.sound.mute = true;
          }
          break;
        }
      case "pause": {
        this._onPauseButtonPress();
        break;
      }
      case "resume": {
        this._onPauseToResume();
        break;
      }
    }
  }

  private _createFPS() {
    this._fps = this.add.text(0, 0, this.game.loop.actualFps + "");
    this._fps.setOrigin(0.5);
    this._fps.setPosition(window.constants["BASE_WIDTH"] * 0.5, this._fps.height);
  }

  private _handleInputListeners(type: string, callback: Function, add: boolean) {
    if (!window.constants["HD_FLAG"]) {
      if (this.input.keyboard) {
        if (add) {
          this.input.keyboard.addListener(type, callback, this);
        } else {
          this.input.keyboard.removeListener(type, callback, this);
        }
      }
    }
  }

  update(time, dt) {
    this._blood.setPosition(window.constants.BASE_WIDTH / 2, window.constants.BASE_HEIGHT / 2);
    if (window.constants["UPDATE_POINTS"]) {
      this.updatePoints();
      window.constants["UPDATE_POINTS"] = false;
    }
    // this._fps.setText("FPS = " + Math.floor(this.game.loop.actualFps)+"");
  }

  private _createAdWaitingPanel() {

    let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;

    this._adWaitingPanelContianer = this.add.container(w2, h2);
    this._adWaitingPanelContianer.setDepth(40);
    let dataContainer = this.add.container(0, 0);

    let fontSize = (window.constants["HD_FLAG"]) ? 60 : 14;

    //text
    let text = this.add.text(0, 0, "loading...", { fontSize: fontSize, fontFamily: "font_3", align: "center" });
    text.setOrigin(0.5, 0.5);

    //let background = this.add.image(0, 5, "black_panel");
    let spinner = this.add.image(0, 0, "spinner");
    let spinnerTween = null;

    text.setPosition(text.x, text.y - 150);

    let rectangle = this.add.rectangle(0, 0, window.constants["BASE_WIDTH"], window.constants["BASE_HEIGHT"], 0x000000, 1);

    dataContainer.add([spinner, text]);
    this._adWaitingPanelContianer.add(rectangle);
    this._adWaitingPanelContianer.add(dataContainer);

    spinnerTween = this.tweens.addCounter({
      from: 0,
      to: 360,
      duration: 3000,
      repeat: -1,
      onUpdate: function (tween) {
        spinner.setAngle(tween.getValue());
      }
    });
  }
}
